import { AiOutlineExclamationCircle } from "react-icons/ai";
import { FormattedMessage } from "react-intl";

import { Container, HighlightText, Text } from "./styles";
import Button from "../button";

function Empty({
  intlId = "informa_academy_empty_text",
  highlightText = "informa_academy_empty_title",
  button,
}) {
  return (
    <Container>
      <AiOutlineExclamationCircle size={30} />
      <HighlightText>
        <FormattedMessage id={highlightText} />
      </HighlightText>
      <Text>
        <FormattedMessage id={intlId} />
      </Text>
      {button && (
        <div
          style={{
            marginTop: 8,
          }}
        >
          <Button
            label={"new_course"}
            href={"/admin/informa-academy/courses/new"}
          />
        </div>
      )}
    </Container>
  );
}

export default Empty;
